const state = {
  benefitTypes: [],
  benefitType: {},
};

export default state;
